import PostalAddress from 'txp-data/lib/schema/innerSchema/PostalAddress';
import PersonaPostalAddress from 'owa-service/lib/contract/PersonaPostalAddress';
import { LocationPersonaControlViewState } from 'owa-location-persona';

export default function createTxpPostalAddressFromLocationPersona(
    locationPersona: LocationPersonaControlViewState | string
): PostalAddress {
    if (typeof locationPersona === 'string') {
        return {
            streetAddress: locationPersona,
        };
    } else {
        const postalAddress: PersonaPostalAddress = locationPersona.postalAddress;
        const streetAddress: string = postalAddress.Street || locationPersona.displayName;
        return {
            displayName: locationPersona.displayName,
            streetAddress: streetAddress,
            addressLocality: postalAddress.City,
            addressRegion: postalAddress.State,
            addressCountry: postalAddress.Country,
            postalCode: postalAddress.PostalCode,
            longitude: postalAddress.Longitude,
            latitude: postalAddress.Latitude,
            postOfficeBoxNumber: postalAddress.PostOfficeBox,
        };
    }
}
